// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_desktopNoteModal_btn-primary__1n_pK","desktop-cancel-purchase":"_desktopNoteModal_desktop-cancel-purchase__21F-r","title":"_desktopNoteModal_title__QyGaa"};